export const getParagraphsFromString = (value: string) => {
  const parts1 = value?.split('\r\n')
  const parts2 = value?.split('\n\n')

  if (parts1.length > 1) return parts1
  if (parts2.length > 1) return parts2
  return parts1 || []
}
